"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var main = document.querySelector('.main-img');
var imgs = document.querySelectorAll('.other-img');
imgs.forEach(function (img) {
    img.addEventListener('click', function (e) {
        main.src = img.src;
    });
});
var aboutProduct = document.querySelector('.product-about');
var aboutSelect = aboutProduct.querySelector('.about-select');
var aboutWrapper = aboutProduct.querySelector('.about-wrapper');
var InfoButton = aboutSelect.querySelector('button.info');
var AboutButton = aboutSelect.querySelector('button.about');
var aboutSection = aboutWrapper.querySelector('.about');
var infoSection = aboutWrapper.querySelector('.info');
var aboutText = aboutSection.querySelector('p');
var infoTable = infoSection.querySelector('table');
var activeSection = 'about';
function update() {
    if (activeSection === 'about') {
        AboutButton.className = 'title_small about active';
        InfoButton.className = 'title_small info';
        aboutSection.className = 'about title_smaller active';
        infoSection.className = 'info title_smaller';
        aboutWrapper.style.height = "calc(".concat(aboutText.getBoundingClientRect().height, "px + 5rem)");
    }
    else {
        AboutButton.className = 'title_small about ';
        InfoButton.className = 'title_small info active';
        aboutSection.className = 'about title_smaller ';
        infoSection.className = 'info title_smaller active';
        aboutWrapper.style.height = "calc(".concat(infoTable.getBoundingClientRect().height, "px + 5rem)");
    }
}
update();
InfoButton.addEventListener('click', function () {
    activeSection = 'info';
    update();
});
AboutButton.addEventListener('click', function () {
    activeSection = 'about';
    update();
});
